import { SvgIconProps } from '@mui/material';
import * as React from 'react';
import { memo } from 'react';

function ChevronDownIcon(props?: SvgIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props} data-testid="chevronDownIcon">
      <path
        stroke={props?.stroke ? props.stroke : '#666'}
        strokeLinecap="round"
        d="M13.667 5.167 8 10.833 2.333 5.167"
      />
    </svg>
  );
}

export function ChevronDownIcon2x(props?: SvgIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={18} height={10} fill="none" {...props}>
      <g clipPath="url(#clip0_7219_1461)">
        <path
          d="M17.5 0.75L9 9.25L0.5 0.75"
          stroke={props?.stroke ? props.stroke : 'currentcolor'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_7219_1461">
          <rect width="18" height="10" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
export default memo(ChevronDownIcon);
